import React from 'react';
import { Tooltip } from 'components';

interface EllipsisTextProps {
  text: string;
  subTitle?: string;
  maxLines?: number;
}

export const MultiLineEllipsisText: React.FC<EllipsisTextProps> = ({ text, subTitle, maxLines = 5 }) => {
  if (!text) return null;
  return (
    <Tooltip title={text}>
      <div className="multiline-ellipsis-text" style={{ WebkitLineClamp: maxLines }}>
        {subTitle && <strong>{subTitle}</strong>} {text}
      </div>
    </Tooltip>
  );
};
